export function photoCaptionAltFormatter(
  caption: string | null | undefined,
): string | null | undefined {
  if (typeof caption !== 'string') {
    return caption
  }
  return caption
    .split('(')[0]
    .replace(/\r?\n/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}
